
import {TextareaAutosize as a} from "react-autosize-textarea/lib/TextareaAutosize";

export const TextareaAutosize:any = a;